var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Edit",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4480",
    "data-name": "Rectangle 4480",
    width: 23.078,
    height: 23.077,
    fill: "#0b8087"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3413",
    "data-name": "Group 3413",
    transform: "translate(9.256 9.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3412",
    "data-name": "Group 3412",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5341",
    "data-name": "Path 5341",
    d: "M10.9,23.074q-2.553,0-5.107,0A5.649,5.649,0,0,1,0,17.309Q0,12.139,0,6.969A5.588,5.588,0,0,1,5.59,1.214c1.912-.041,3.825-.014,5.738,0,.714,0,1.066.308,1.066.873s-.351.867-1.067.871c-1.786.009-3.572,0-5.359,0a3.889,3.889,0,0,0-4.2,4.2q0,5.013,0,10.025a3.883,3.883,0,0,0,4.1,4.124q5.074.006,10.151,0a3.865,3.865,0,0,0,4.1-4.046c.018-1.828.006-3.657,0-5.486,0-.5.1-.933.658-1.069.635-.154,1.082.249,1.089,1.011.013,1.534.021,3.068,0,4.6A12.3,12.3,0,0,1,21.7,18.7a5.53,5.53,0,0,1-5.442,4.372c-1.786.011-3.573,0-5.359,0",
    transform: "translate(0 0)",
    fill: "#0b8087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5342",
    "data-name": "Path 5342",
    d: "M9.332,17.154c-.8,0-1.6.009-2.4,0a.906.906,0,0,1-1.011-1.013c-.01-1.576-.023-3.153.014-4.728a1.417,1.417,0,0,1,.37-.88Q11.077,5.713,15.887.939A3.174,3.174,0,0,1,20.33.875,24.3,24.3,0,0,1,22.2,2.746a3.177,3.177,0,0,1-.109,4.49Q17.36,12,12.589,16.723a1.7,1.7,0,0,1-.989.412c-.751.061-1.511.019-2.268.019M7.694,15.382a9.372,9.372,0,0,1,1.471.012,4.083,4.083,0,0,0,3.966-1.627c1.71-1.9,3.6-3.635,5.371-5.4L14.728,4.584c-2.26,2.26-4.547,4.544-6.825,6.836a.7.7,0,0,0-.2.431c-.016,1.151-.009,2.3-.009,3.531M16.148,3.156l3.74,3.8c.32-.324.672-.652.992-1.009a1.41,1.41,0,0,0,0-2.035q-.837-.894-1.733-1.731a1.382,1.382,0,0,0-1.937-.055c-.394.335-.747.721-1.059,1.026",
    transform: "translate(0 0)",
    fill: "#0b8087"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    fill: "none",
    stroke: "#0b8087",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/Icon_Edit.c3a16d6076c6a3dfdc52fae316b47718.svg";
export { ForwardRef as ReactComponent };